import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../components/Loader/Loader.sass"
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'
import { apiUser } from "../basedata/apiCall";
import InfoModal from "../components/Modal/ModalInfo"
import { useStep } from "../context/StepContext";

const Validating = () => {

  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const { setStep } = useStep();

  const handleAcceptTerms = () => {
    setAccepted(!accepted);
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error_message, setError_message] = useState('A sua selfie e a foto do documento não batem.');
  const closeModal = async () => {
    const _temp_token = sessionStorage.getItem('token')
    const _validate_doc = await apiUser.get(`/biometry/onboarding/retry?uid=${_temp_token}`)
    setIsModalOpen(false);
    window.location.href = '/document-handler'
  };

    const getUserFlow = async (userToken:any) => {
    try {

      const _response = await apiUser.post(`/biometry/onboarding/user-jorney`, { flowId: userToken })

      if (_response.data.status === 'success') {
        sessionStorage.setItem('user_history', _response.data.message)
        sessionStorage.setItem('get_flow_index', 'true')
        sessionStorage.setItem('document_type', _response.data.document_type || 'cpf')


        const _current_location = window.location.pathname
        if (_response.data.message === 'selfie') {
          window.location.href = 'instructions';
        } else if (_response.data.message === 'document_front') {
          window.location.href = 'instructions-document?verse=false';
        } else if (_response.data.message === 'document_back') {
          window.location.href = 'instructions-document?verse=false';
        } else if (_response.data.message === 'done') {
          if (!/success/.test(_current_location)) {
            window.location.href = 'success'
          }
        }
      }else{
        window.location.href = 'instructions';
      }

    } catch (e) {
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    }
    }


  

  useEffect(() => {
    setStep(5);
    const params = new URLSearchParams(window.location.search)
    let currentToken = params.get('token'),
    currentCompany = params.get('orc')

    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
    }else{
    currentToken = sessionStorage.getItem('token')
    currentCompany = sessionStorage.getItem('orc')
    }

    if(!currentToken){
      console.log('utautauta')
      window.location.href = '/'
    }

    getUserFlow(currentToken);
  }, []);



  return (
    <>
        <InfoModal isOpen={isModalOpen} onClose={closeModal}>
            <h1>Opa!</h1>
            <p>{error_message}</p>
            <button className='button-retry-action' onClick={closeModal}>{t('success_document.try_again')}</button>
        </InfoModal>
    </>
  );
};

export default Validating;